import {createContext} from "react";
import {IAppInitializationContext} from "./models/IAppInitializationContext.ts";

export const AppInitializationContext = createContext<IAppInitializationContext>({
    initialize: function (): void {    }
});
